/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  accountsCountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGet,
} from "../../funcs/accountsCountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .CountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGetRequest$inboundSchema,
};

export const tool$accountsCountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGet:
  ToolDefinition<typeof args> = {
    name: "account-tx-count-v2",
    description: `Original tool name: api-v2-ledgers-ledger-canister-id-accounts-id-transactions-count-get

Get the total count of transactions matching the given criteria

This endpoint returns the total count of transactions matching the given criteria.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await accountsCountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsCountGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };